// src/components/TailwindScopedWrapper.jsx
import React from "react"
// eslint-disable-next-line import/no-webpack-loader-syntax
import kooft from "!!raw-loader!../css/tailwind.compiled.inline.css"

export default function TailwindWrapper({
  children,
}: {
  children: React.ReactNode
}) {
  React.useEffect(() => {
    const style = document.createElement("style")
    style.innerHTML = kooft
    document.head.appendChild(style)

    return () => {
      document.head.removeChild(style)
    }
  }, [])
  return <div>{children}</div>
}
